/** Catches unexpected render errors so the iframe never shows a blank white screen. */
import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}
interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <main className="center-screen" role="alert">
          <p>Something hiccupped.</p>
          <p className="muted">Try closing and reopening the activity. 🖤💛</p>
        </main>
      );
    }
    return this.props.children;
  }
}
